export default async (module_id,actualRoom,settings) =>
{
    console.log('%c 📄 HTML-Code Module Loaded! ', 'background: #222; color: #bada55');
    const data = await (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=metadata`)).json();

    [].forEach.call(data.user.groups, function(group) {
      if(data.group_everyone === group["id"])
      {
        Echo.channel(`room.${actualRoom}.module.${module_id}.group.${group["id"]}.settings`)
        .listen('ModuleSettingsUpdate', async (event) => { handleModuleUpdate(event) });
      }
      else {
        Echo.private(`room.${actualRoom}.module.${module_id}.group.${group["id"]}.settings`)
        .listen('ModuleSettingsUpdate', async (event) => { handleModuleUpdate(event) });

      }
  });

  async function handleModuleUpdate(event)
   {
     if(event.settings.enabled === "0")
     {
        document.querySelector(`[data-module-relation-id='${module_id}'] [data-module-content]`).innerHTML = "";
     }
     else {
       console.log(`/room/${actualRoom}/module/${module_id}/api?`);
        const data = await (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=content`)).json();
        document.querySelector(`[data-module-relation-id='${module_id}'] [data-module-content]`).innerHTML = data.compiled_html;
     }
   }
};
